import { artistPreviewSchema } from "../schemas";
import {
  makeAnyKeySelector,
  makeCollectionSelector,
  makeAnyKeyCollectionSelector,
  makeFetchStatusSelector,
} from "./collections";

export const DEFAULT_COLLECTION = "index";

export function makeViewAnyKeySelector(key, collection) {
  return makeAnyKeySelector(key, collection, artistPreviewSchema);
}

export function makeArtistPreviewsSelector(collection = DEFAULT_COLLECTION) {
  return makeCollectionSelector(collection, artistPreviewSchema);
}

export function makeArtistPreviewsAnyKeySelector(key, collection = DEFAULT_COLLECTION) {
  return makeAnyKeyCollectionSelector(key, collection, artistPreviewSchema);
}

export function makeArtistPreviewsFetchStatusSelector(collection = DEFAULT_COLLECTION) {
  return makeFetchStatusSelector(collection, artistPreviewSchema);
}